import React, {useEffect, useState} from 'react';

import {useQueryParams} from 'presentation/pages/private/hooks';
import {
	DISTANCE_MARKS,
	DISTANCE_VALUES,
	DISTANCE_MARKS_ODONTO,
	DISTANCE_VALUES_ODONTO,
} from './constants';
import {useDistanceSliderStore} from './store';
import {CustomSlider} from './styles';
import {DistanceSliderProps} from './types';

export function DistanceSlider({drawerIsOpen, isOdonto}: DistanceSliderProps) {
	const {SEARCH_PARAMS} = useQueryParams();
	const setDistanceSlider = useDistanceSliderStore(state => state.setDistanceSlider);
	const [localSliderValue, setLocalSliderValue] = useState(0);
	const MARKS = isOdonto ? DISTANCE_MARKS_ODONTO : DISTANCE_MARKS;
	const VALUES = isOdonto ? DISTANCE_VALUES_ODONTO : DISTANCE_VALUES;
	const distanceIndex = MARKS.findIndex(mark => mark.value === localSliderValue);

	const {localityDistance} = SEARCH_PARAMS;

	useEffect(() => {
		if (localityDistance) {
			const distanceValue = Number(localityDistance);
			const index = MARKS.findIndex(mark => mark.label === `${distanceValue}km`);

			if (index !== -1) {
				setLocalSliderValue(index);
				setDistanceSlider(distanceValue);
			} else {
				const closestIndex = VALUES.reduce((prevIndex, currentValue, currentIndex) => {
					const prevDiff = Math.abs(distanceValue - VALUES[prevIndex]);
					const currentDiff = Math.abs(distanceValue - currentValue);
					return currentDiff < prevDiff ? currentIndex : prevIndex;
				}, 0);

				setLocalSliderValue(closestIndex);
				setDistanceSlider(VALUES[closestIndex]);
			}
		}

		return () => {
			setLocalSliderValue(0);
			setDistanceSlider(VALUES[0]);
		};
	}, [localityDistance, setDistanceSlider, drawerIsOpen]);

	const handleChange = (event: Event, newValue: number | number[]) => {
		const value = Number(newValue);
		setLocalSliderValue(value);
		setDistanceSlider(VALUES[value]);
	};

	return (
		<CustomSlider
			defaultValue={0}
			value={localSliderValue}
			step={null}
			size="small"
			valueLabelDisplay="off"
			marks={MARKS}
			onChange={handleChange}
			$activeIndex={distanceIndex}
			max={isOdonto ? 4 : 3}
		/>
	);
}
